import * as React from "react";
import LinearProgress from "@mui/material/LinearProgress";

declare const window: any;

export default function CardV1({
  intro,
  progress,
  theme,
  setIntroView,
  isLoaded,
  isPortrait,
  counter,
}: any) {
  const [timeLoad, setTimeLoad] = React.useState(0);
  //console.log(intro);

  React.useEffect(() => {
    // Aquí puedes definir el color de fondo de la clase intro-cardv1-load-bar
    const loadBar: any = document.querySelector(".intro-cardv1-load-bar");
    if (loadBar) {
      loadBar.style.backgroundColor = "#fff";
    }

    // Aquí puedes definir el color de fondo del span dentro del componente
    const spanElement: any = document.querySelector(
      ".intro-cardv1-load-bar span"
    );
    if (spanElement) {
      spanElement.style.backgroundColor = intro?.colors?.main_buttons; // Puedes ajustar el color que desees aquí
    }
  }, [intro?.colors?.main_buttons]);

  const handleIngreso = () => {
    const containerWrapper: any = document.querySelector(
      ".intro-cardv1-container-wrapper"
    );
    //containerWrapper.classList.remove("ocultar-intro-container");
    containerWrapper.classList.add("ocultar-intro-container");
    setTimeout(() => {
      setIntroView(false);
      containerWrapper.classList.add("ocultar");
    }, 501);
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  return (
    <div
      className={`intro-cardv1-container-wrapper ${
        Object.keys(intro).length > 0 ? "active" : ""
      }`}
    >
      <div className={`intro-cardv1-container ${theme}`}>
        <div
          className="intro-cardv1-logos"
          style={
            intro?.logos_multiples?.length > 1
              ? { display: "grid", justifyItems: "center" }
              : intro?.logo_invertido
              ? { flexDirection: "row-reverse" }
              : {}
          }
        >
          {intro?.logos_multiples?.length > 1 ? (
            <div className="intro-cardv1-logos-multiples">
              <img
                style={
                  intro?.logos_multiples?.length > 0
                    ? { marginBottom: "0.75rem", marginTop: "0.75rem" }
                    : {}
                }
                className={intro?.logos_multiples?.length > 2 ? "doble" : ""}
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://d1bsymnertnea6.cloudfront.net/"
                }galleries/${window?.builder_id}/logo.svg`}
                alt=""
              />
              {intro?.logos_multiples?.map((item: any) => (
                <img
                  style={
                    intro?.logos_multiples?.length > 0
                      ? { marginBottom: "0.75rem", marginTop: "0.75rem" }
                      : {}
                  }
                  className={intro?.logos_multiples?.length > 2 ? "doble" : ""}
                  src={`${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net/"
                  }${item.link}`}
                  alt=""
                />
              ))}
            </div>
          ) : null}
          {intro?.logos_multiples?.length === 0 &&
          intro?.active_builder_logo ? (
            <img
              src={`${
                window.hybrid
                  ? "./"
                  : "https://d1bsymnertnea6.cloudfront.net/"
              }galleries/${window?.builder_id}/logo.svg`}
              alt=""
            />
          ) : null}
          <img
            style={
              intro?.logos_multiples?.length > 1
                ? { marginBottom: "0.75rem", marginTop: "0.75rem" }
                : {}
            }
            className={intro?.logos_multiples?.length === 1 ? "small" : ""}
            src={`${
              window.hybrid
                ? "./"
                : "https://d1bsymnertnea6.cloudfront.net/"
            }galleries/${window?.builder_id}/${window?.project_id}/logo.svg`}
            alt=""
          />
          {intro?.logos_multiples?.length === 1 ? (
            <>
              <img
                className={intro?.logos_multiples?.length === 1 ? "small" : ""}
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://d1bsymnertnea6.cloudfront.net/"
                }galleries/${window?.builder_id}/logo.svg`}
                alt=""
              />
              <img
                className={intro?.logos_multiples?.length === 1 ? "small" : ""}
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://d1bsymnertnea6.cloudfront.net/"
                }${intro?.logos_multiples[0].link}`}
                alt=""
              />
            </>
          ) : null}
        </div>
        <div className="intro-cardv1-legal-text">{intro?.texto_legal}</div>
        {progress >= 100 || (progress >= 80 && counter >= 180) ? (
          <div
            className="intro-cardv1-ingresar"
            style={{
              backgroundColor: intro?.colors?.main_buttons,
              color: intro?.colors?.secondary_text,
              marginTop: "40px"
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = darkenColor(
                intro?.colors?.main_buttons,
                -0.2
              );
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor =
                intro?.colors?.main_buttons;
            }}
            onClick={() => handleIngreso()}
            data-type={"INGRESO"}
            data-value={"INGRESO"}
          >
            Aceptar
          </div>
        ) : (
          <div className="intro-cardv1-load">
            <span>Cargando...</span>
            <LinearProgress
              variant="determinate"
              className="intro-cardv1-load-bar"
              value={progress}
            />
            <p>{progress}%</p>
          </div>
        )}
        <div className="intro-cardv1-poweredBy">
          Powered by ® Umbra Group - 2025
        </div>
      </div>
    </div>
  );
}
